<template>
	<div class="homePage_inlinet" :key="module.title">
		<Panel hasShadow style="height: 488px" class="rank-pannel">
			<div class="flex-row flex-just-between">
				<span class="font-h2-medium flex-row-align-center">
					{{ module.title }}
					<Explain :content="module.tipContent" v-if="module.tipContent" class="ml-4" icon="icon-a-help-circlebangzhu-mian" size="20"></Explain>
				</span>
			</div>
			<div class="main-content" v-loading="module.loading">
				<div class="pos-rela pt-20 flex-row data-content">
					<div class="content flex-row-align-center flex-1">
						<div class="flex-row flex-1">
							<div style="width: 160px">
								<div
									class="flex-row flex-align-start flex-just-end mt-20"
									:class="{ 'mt-4': !!index }"
									:style="'opacity: ' + (0.3 * 10 + index * 0.1 * 10) / 10"
									v-for="(item, index) in module.list"
									:key="item.title"
								>
									<div class="trapezoid primary-bg"></div>
									<div :style="'width: ' + (120 - index * 20) + 'px; height: 41px'" class="primary-bg"></div>
								</div>
							</div>
							<div class="flex-1">
								<div
									class="mt-20 flex-row primary-bg flex-row-align-center flex-just-end pr-12 item"
									:class="[!!index ? ' mt-4' : '', `opacity-${3 + index}`]"
									style="height: 41px"
									v-for="(item, index) in module.list"
									:key="item.title"
								>
									<span class="Barlow-Bold yx-color-white">{{ item.value | formatEmpty | formatPrice2 }}</span>
									<span class="font-h6-regular yx-color-white ml-8">{{ item.title }}</span>
								</div>
							</div>
						</div>
						<div style="width: 130px; margin-top: 60px">
							<div
								class="pl-4 flex-row-align-center mt-20"
								style="height: 41px"
								v-for="(item, index) in module.list"
								:key="item.title"
								:class="{ 'mt-12': !!index }"
							>
								<div class="flex-row-align-center" v-if="index < module.list.length - 1">
									<el-image :src="require('@/assets/public/home-back-icon-1.png')" class="mt-4" style="width: 16px; height: 48px" lazy></el-image>
									<div>
										<span class="yx-color-text-secondary font-h6-regular ml-4">{{ item.label }}</span>
										<span class="Barlow-Bold yx-color-text-primary ml-4">{{ item.rate | formatEmpty }}%</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Panel>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';
import { mapGetters } from 'vuex';
import { getProductConversion, getTalentAnalyse } from '@/api/home';
import { debounce } from 'lodash';

export default {
	props: {
		showKey: {
			type: String,
			default: '',
		},
		platformId: {
			type: [Number, String],
			default: null,
		},
		deptIds: {
			type: Array,
			default: () => {
				return [];
			},
		},
		authorityId: {
			type: [Number, String],
			default: null,
		},
	},
	components: {
		Explain,
	},
	data() {
		return {
			conversionModule: [],
			conversionMap: new Map([
				[
					'anchor',
					{
						title: '达人转化',
						key: 'anchor',
						tipContent: '筛选单个团长数据时，“达人总数”、“建联达人数”数据不变化',
						loading: false,
						list: [
							{ title: '全部达人', value: 0, rate: 0 },
							{ title: '建联达人', value: 0, rate: 0 },
							{ title: '申样达人', value: 0, rate: 0 },
							{ title: '发货达人', value: 0, rate: 0 },
							{ title: '开播达人', value: 0, rate: 0 },
							{ title: '动销达人', value: 0, rate: 0 },
						],
					},
				],
				[
					'product',
					{
						title: '商品转化',
						key: 'product',
						loading: false,
						list: [
							{ title: '全部商品', value: 0, rate: 0 },
							{ title: '推广商品', value: 0, rate: 0 },
							{ title: '申样商品', value: 0, rate: 0 },
							{ title: '发货商品', value: 0, rate: 0 },
							{ title: '开播商品', value: 0, rate: 0 },
							{ title: '动销商品', value: 0, rate: 0 },
						],
					},
				],
			]),
		};
	},
	created() {
		this.conversionModule = [...this.conversionMap.values()];
		this.getData(this.showKey);
	},
	computed: {
		...mapGetters(['isShopPartnerDataView']),
		searchParameters() {
			return {
				platform_id: this.platformId,
				deptIds: this.deptIds,
				authority_id: this.authorityId,
			};
		},
		module() {
			return this.conversionModule.find(item => item.key === this.showKey);
		},
	},
	watch: {
		searchParameters: {
			handler(val) {
				this.getData(this.showKey);
			},
			deep: true,
		},
	},
	methods: {
		async getData(key) {
			const conversionData = new Map([
				['anchor', getTalentAnalyse],
				['product', getProductConversion],
			]);
			await this.updateConversionData(key, conversionData.get(key));
		},
		async updateConversionData(key, getDataFunc) {
			const rankObject = this.conversionMap.get(key);
			rankObject.loading = true;
			this.conversionModule = [...this.conversionMap.values()];
			try {
				const { data = [] } = await getDataFunc({
					...this.searchParameters,
				});
				rankObject.list = rankObject.list.map(item => {
					const updatedItem = data.find(item1 => item1.title === item.title);
					return updatedItem ? updatedItem : { title: item.title, value: 0, rate: 0 };
				});
				rankObject.loading = false;
				this.conversionMap.set(key, rankObject);
				this.conversionModule = [...this.conversionMap.values()];
			} catch (error) {
				console.error(`Error fetching data for ${key}:`, error);
				rankObject.loading = false;
				this.conversionModule = [...this.conversionMap.values()];
			}
		},
	},
};
</script>
<style lang="less" scoped>
.homePage_inlinet {
	width: 50%;
	box-sizing: border-box;
	margin-top: 16px;

	&:nth-child(odd) {
		padding-right: 8px;
	}

	&:nth-child(even) {
		padding-left: 8px;
	}
}
.rank-pannel {
	display: flex;
	/deep/ .panel-body {
		display: flex;
		width: 100%;
		box-sizing: border-box;
		flex-direction: column;
		.data-content {
			flex: 1;
			// display: flex
		}
	}
}
.main-content {
	flex: 1;
}
.pos-rela {
	padding-top: 20px;
	margin-top: -20px;
	position: relative;
	top: 50%;
	transform: translateY(-50%);
}

.content {
	margin-left: 63px;
	width: 100%;
	height: 218px;
	background-color: #fff;
}
.primary-bg {
	background-color: @color-primary;
}
.trapezoid {
	margin-right: -12px;
	width: 40px;
	height: 41px;
	transform: skewX(30deg);
	border-radius: 4px 0 0 4px;
}
.opacity-8 {
	background-color: fadeout(@color-primary, 20);
}
.opacity-7 {
	background-color: fadeout(@color-primary, 30);
}
.opacity-6 {
	background-color: fadeout(@color-primary, 40);
}
.opacity-5 {
	background-color: fadeout(@color-primary, 50);
}
.opacity-4 {
	background-color: fadeout(@color-primary, 60);
}
.opacity-3 {
	background-color: fadeout(@color-primary, 70);
}
.item {
	border-radius: 0 4px 4px 0;
}
</style>
